import React, { useEffect, useState } from "react";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { useDateHelper } from "../../hooks/useHelper";
import { ForumPostCard } from "../Forum/ForumPostCard";
import { AdminIcons } from "../Shared/AdminIcon";
import { ToolBar } from "../ToolBar/ToolBar";
import { LoadingBar, Padder, ScreenHeader, ScreenMenu } from "../UI/Elements";
import { JwtImage } from "../UI/ImageElements";
import { useElasticMenu } from "./useElasticMenu";
import { useElasticSearch } from "./useElasticSearch";

export const ElasticSearchPosts = () => {
    const ui = useElasticSearch();
    const dh = useDateHelper();

    useEffect(() => {
        ui.load();
    }, []);

    useEffect(() => {
        document.getElementById("ui-content-children").scrollTop = 0;
    }, [ui.posts?.hits])


    const [search, setSearch] = useState<string>("");
    const menu = useElasticMenu();

    const tagClicked = (e: string) => {
        ui.onSearchTag(e);
    }

    return (
        <div className="screen-elastic">
            <ScreenHeader text="Sök inlägg med Elastic Search" icon={AdminIcons.user} />
            <ScreenMenu items={menu?.items} />

            <LoadingBar loading={ui.loadingPosts} />
            <div>
                <input
                    placeholder="Sök..."
                    className="frm"
                    type={"search"}
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    onKeyUp={e => {
                        if (e.key === "Enter") {
                            ui.onSearchPosts(search);
                        }
                    }} />
            </div>

            <div>
                <div>
                    Träffar: {ui?.posts?.total ?? 0} - Svarstid: {ui.posts?.durationms} ms.
                </div>

                <div className="tagcloud">
                    {Object.keys(ui.postsTagCloud)?.filter(key => ui.postsTagCloud[key] > 1)?.filter((key, idx) => idx < 30).map(key => (
                        <span key={key} className={"tagcloud-item" + (key === ui.selectedTag ? " selected" : "")} onClick={() => tagClicked(key)}>
                            {key} ({ui.postsTagCloud?.[key]})
                        </span>
                    ))}
                </div>

                <table className="tbl tbl-small">
                    <thead>
                        <tr>
                            <th>Alias</th>
                            <th>Likes</th>
                            <th>Typ</th>
                            <th>Text</th>
                            <th>Datum</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ui.posts?.hits?.map(hit => (
                            <tr key={hit?.id} className="tbl-user-post">
                                <td>
                                    {hit?.alias} <br />
                                    {hit?.gardenitemname}
                                </td>
                                <td>{hit?.numberoflikes}</td>
                                <td>{hit?.poststate}</td>
                                <td>
                                    {!!hit?.isquestion && (
                                        <div className="bold">Fråga:</div>
                                    )}
                                    <div className="text">{hit?.text}</div>

                                    <div className="post-images">
                                        {hit.imageids?.map(img => (
                                            <JwtImage
                                                key={img}
                                                imageId={img}
                                                format={"thumb"}
                                                containerClassName="post-image"
                                                openOnClick={true}
                                            />
                                        ))}
                                    </div>

                                    {(hit?.keywords ?? []).length > 0 && (
                                        <div className="keywords"><span className="bold">Keywords:</span>
                                            {(hit?.keywords ?? [])?.map(p => (
                                                <span className="keyword" onClick={() => tagClicked(p)}>
                                                    {p}
                                                </span>
                                            ))}
                                        </div>
                                    )}

                                    {!!hit?.plantnames && (
                                        <div className="plantnames"><span className="bold">Växter:</span>  {hit?.plantnames}</div>
                                    )}
                                </td>
                                <td>{dh.timeAgo(hit?.epochposted)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Padder.Horizontal size="50px" />
            </div>
        </div>
    )
}
